<template>
    <div :style="''">
        <el-tabs class="x-tab" type="border-card" v-model:model-value="currentTab">
            <template v-for="(tabConfig) in getFields(config.fields, data)" :key="tabConfig.code">
                <el-tab-pane v-show="getVisible(tabConfig.fullCode, tabConfig.visible, tabConfig.fullModule, data)" :name="tabConfig.code"
                    :label="tabConfig.name">
                    <slot v-if="currentTab == tabConfig.code" name="default" :config="tabConfig"
                        :readonly="readonly || tabConfig.readonly" :query-params="queryParams"></slot>
                </el-tab-pane>
            </template>
        </el-tabs>
    </div>
</template>
<script setup>
import { defineProps, getCurrentInstance, ref, watch, onActivated } from 'vue';
import { getBoolean, getPermissions } from '../../business/Computer';
import DataPermissionManager from '../../datapermission/DataPermissionManager';
import { useRoute } from 'vue-router';
import PermissionManager from '../../permission/PermissionManage';

let route = useRoute();
const inst = getCurrentInstance();

const currentTab = ref(null);

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },
    queryParams: { default: null },
})

onActivated(()=> {
    refereshKey.value = refereshKey.value + 1;
})

// const r = ref(null);
const refereshKey = ref(0);
const getFields = (fields, data)=> {
    const fs = [];
    for (const field of fields) {
        if (getVisible(field.code, field.visible, field.fullModule, data)) fs.push(field);
    }
    return fs;
}

const getVisible = (code, visible, module, data) => {
    // console.log('%ctab code ' + code + name, "color:#FF0000")
    
    // process function permission
    // v=true
    if (!module) return true;
    let v = true;
    
    // v = v && getPermissions(code, inst.proxy.$router.currentRoute.value.path);
    v = v && PermissionManager.checkPermission(module);
    if (!v) return false;
    if (!data) return true;
    let hasData = false;
    for (let i in data) {
        hasData = true;
        break;
    }
   
    if (hasData) {
        v = getBoolean(visible, data, true);
        // process data permission
        v = v && DataPermissionManager.checkDataPermission(module, data);
        return v;
    }
    return true;
}

watch(() => props.data, (value) => {
    // r.value = Date.now();
    const def = route.query?.tab;
    if (value || def) {
        for (const tab of props.config?.fields) {
            if (getVisible(tab.fullCode, tab.visible, tab.fullModule, value) && (!def || tab.code == def)) {
                currentTab.value = tab.code;
                break;
            }
        }
    }
    if (!currentTab.value && props.config?.fields) {
        for (const tab of props.config?.fields) {
            if (getVisible(tab.fullCode, tab.visible, tab.fullModule, value)) {
                currentTab.value = tab.code;
                break;
            }
        }
    }
}, { immediate: true })
</script>